import { h, Fragment } from "preact";

export default function ProductDiscontinued({ product, variants }) {
  if (!product || !variants.length) return null;

  const allSoldOut = variants.every((variant) => JSON.parse(variant.hideOnPdp));

  const redirectUrl = allSoldOut
    ? product.helpers.discontinuedRedirectUrl
    : product.helpers.url;

  return (
    <div className="product-form__discontinued">
      <div
        className="product-form__discontinued-copy"
        dangerouslySetInnerHTML={{
          __html: window.localeStrings.product.discontinued.copy_html,
        }}
      ></div>
      {redirectUrl && (
        <a href={redirectUrl} className="product-form__discontinued-link">
          {window.localeStrings.product.discontinued.link_text}
        </a>
      )}
    </div>
  );
}
